<template>
    <swiper class="swiper c-swiper" :options="swiperOption">
        <swiper-slide v-for="(img,i) in details" :key="i">
            <!--      <div class="img-contain bg-cover cursor-pointer d-sm-none" :style="setImage(img.image)"></div>-->
            <!--      <div v-if="img.mobile_image" class="img-contain bg cursor-pointer d-lg-none"-->
            <!--           :style="setImage(img.mobile_image)"></div>-->
            <!-- <div class="img-contain cursor-pointer bg-cover" :style="setImage(img.image)"></div> -->
             <div class="img-contain">
    <img
        :src="img.image"
        class="banner-image"
        alt="Banner"
    >
</div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
</template>
<script> import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import img1 from '../../assets/web/home/banner-bg.svg';
import img1Mobile from '../../assets/web/home/banner-mobile.svg';
// import img3 from '../../assets/web/home/nils-leonhardt-YeBI31kK2_4-unsplash.jpg';

export default {
    name: 'BannerSlider',
    props: {
        details: {
            type: Array, default: null
        }
    },
    title: 'Fade effect',
    components: { Swiper, SwiperSlide },
    data () {
        return {
            swiperOption: {
                autoHeight: true,
                slidesPerView: 1,
                spaceBetween: 0,
                pagination: { el: '.swiper-pagination', clickable: true },
                mousewheel: false,
                parallax: false,
                centeredSlides: true,
                // autoplay: true,
                autoplay: { delay: 6000, disableOnInteraction: false },
                navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
                breakpoints: {
                    1200: { speed: 1500 },
                    1024: { slidesPerView: 1, spaceBetween: 0, speed: 1000 },
                    768: { slidesPerView: 1, spaceBetween: 0, speed: 800 },
                    640: { slidesPerView: 1, spaceBetween: 0, speed: 800 },
                    320: { slidesPerView: 1, spaceBetween: 0, speed: 800 }
                }
            },
            images: [
                {
                    webImg: img1,
                    mobile: img1Mobile
                }
            ]
        };
    },
    methods: {
        setBgImage (image, screen) {
            if (screen === 'web') {
                return { backgroundImage: 'url(' + image.webImg + ')' };
            } else if (screen === 'mobile') {
                return { backgroundImage: 'url(' + image.mobile + ')' };
            }
        },
        setImage (image) {
            return { backgroundImage: 'url(' + image + ')' };
            // return { backgroundImage: 'url(' + img3 + ')' };
        }
    }
}
; </script>
<style lang="scss" scoped>
   /* ===========================
   Banner Image Fix
   Add this at the END of the style section
=========================== */

.swiper {
    height: 50vh !important;

    @media (min-width: 768px) and (max-width: 1024px) {
        height: 30vh !important;
    }
}

.swiper-slide {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    overflow: hidden;
}

.img-contain {
    width: 100% !important;
    height: 100% !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    overflow: hidden !important;
    background: #fff;
}

.banner-image {
    width: 100% !important;
    height: 100% !important;
    max-width: 100% !important;
    max-height: 100% !important;
    object-fit: contain !important;
    object-position: center center !important;
    display: block !important;
}.swiper {
    width: 100%;
    height: auto !important;
}

.swiper-slide {
    width: 100%;
    display: flex !important;
    justify-content: center;
    align-items: center;
}

.img-contain {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.banner-image {
    display: block;
    width: 100%;
    height: auto;
    max-width: 100%;
}</style>
